import { MicroviewCommunicationChannel } from '@tableau/microview-communication-service';

export class EnsureSearchTelemetryInitializationChannel extends MicroviewCommunicationChannel<{ isOnlineEnvironment: boolean }, void> {
  public name: string = 'EnsureSearchTelemetryInitializationChannel';
  public namespace: string = 'VPC.SearchTelemetry';
}

export class IsSearchFlowStartedChannel extends MicroviewCommunicationChannel<void, { isSearchFlowStarted: boolean }> {
  public name: string = 'IsSearchFlowStartedChannel';
  public namespace: string = 'VPC.SearchTelemetry';
}

export class StartSearchFlowChannel extends MicroviewCommunicationChannel<{ OmniboxTelemetryEventSource: unknown }, void> {
  public name: string = 'StartSearchFlowChannel';
  public namespace: string = 'VPC.SearchTelemetry';
}

export class EndSearchFlowWithNoResultEventChannel extends MicroviewCommunicationChannel<
  {
    OmniboxTelemetryEventSource: unknown;
    searchTerm: string;
  },
  void
> {
  public name: string = 'EndSearchFlowWithNoResultEventChannel';
  public namespace: string = 'VPC.SearchTelemetry';
}

export class SendSearchTermUpdatedEventChannel extends MicroviewCommunicationChannel<
  {
    OmniboxTelemetryEventSource: unknown;
    actualSearchText: string;
  },
  void
> {
  public name: string = 'SendSearchTermUpdatedEventChannel';
  public namespace: string = 'VPC.SearchTelemetry';
}
